import flatpickr from 'flatpickr';
import locale from 'flatpickr/dist/l10n/de';
import 'flatpickr/dist/themes/light.css';

flatpickr.localize(locale.de);

export default flatpickr;
